import { useDispatch } from "react-redux";
import {
  storePssSelectAsideShow,
  storePssSelectSidebarShow,
  storePssSetLayout,
} from "../datasources/_pss.layout.store.slice";
import { usePssTypedSelector } from "../../../configs/_pss.store.slice";

export const usePssHeaderController = () => {
  const dispatch = useDispatch();
  const sidebarShow = usePssTypedSelector(storePssSelectSidebarShow);
  const asideShow = usePssTypedSelector(storePssSelectAsideShow);

  const setSidebarShow = (sidebarShow: boolean) => {
    dispatch(storePssSetLayout({ sidebarShow: sidebarShow }));
  };

  const setAsideShow = (asideShow: boolean) => {
    dispatch(storePssSetLayout({ asideShow: asideShow }));
  };

  return {
    state: {
      sidebarShow,
      asideShow,
    },
    action: {
      setSidebarShow,
      setAsideShow,
    },
  };
};
